'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDemo = require('react-demo');

var _reactDemo2 = _interopRequireDefault(_reactDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICON_SIZES = [null, '1x', 'lg', '2x', '3x', '4x', '5x'];
var ICON_ANIMATES = [null, 'spin', 'pulse'];

var Icon = function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          name = _props.name,
          size = _props.size,
          fixed = _props.fixed,
          li = _props.li,
          border = _props.border,
          className = _props.className,
          animate = _props.animate,
          rest = _objectWithoutProperties(_props, ['name', 'size', 'fixed', 'li', 'border', 'className', 'animate']);

      return _react2.default.createElement('i', _extends({
        className: (0, _classnames2.default)('fa fa-' + name, (_cx = {
          'fa-border': border,
          'fa-fw': fixed,
          'fa-li': li
        }, _defineProperty(_cx, 'fa-' + size, size), _defineProperty(_cx, 'fa-' + animate, animate), _cx), className)
      }, rest));
    }
  }]);

  return Icon;
}(_react.PureComponent);

Icon.sizes = ICON_SIZES;
Icon.animates = ICON_ANIMATES;
Icon.propTypes = {
  name: _react.PropTypes.string.isRequired,
  size: _react.PropTypes.oneOf(ICON_SIZES),
  fixed: _react.PropTypes.bool,
  li: _react.PropTypes.bool,
  border: _react.PropTypes.bool,
  animate: _react.PropTypes.oneOf(ICON_ANIMATES),
  className: _react.PropTypes.string
};
Icon.defaultProps = {
  size: null,
  fixed: false,
  li: false,
  border: false,
  animate: null,
  className: null
};

Icon.demo = function () {
  return _react2.default.createElement(_reactDemo2.default, {
    target: Icon,
    props: {
      name: _reactDemo.props.string('beer'),
      size: _reactDemo.props.choices(Icon.sizes),
      animate: _reactDemo.props.choices(Icon.animates),
      fixed: _reactDemo.props.bool(false),
      li: _reactDemo.props.bool(false),
      border: _reactDemo.props.bool(false)
    }
  });
};

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/Icon.js
// module id = 40
// module chunks = 0